import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net';
import { useLocation, useNavigate } from "react-router";
import baseConfig from "../../core/config/Config";
import {ProductService} from "./Service";
import toast from "react-hot-toast";



const ManageProducts = () => {
    const [service] = useState(new ProductService());
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        try {
            $('#table').DataTable().destroy();
        } catch (e) {
            console.log(e);
        }
        let token = localStorage.getItem('token')
        $('#table').DataTable({
            lengthMenu: [10, 20, 50, 100, 500, 1000],
            pageLength: 100,
            processing: true,
            serverSide: true,
            columnDefs: [
                {

                    "render": function (data, type, row) {
                        if (data) {
                            return `<div class="figure"><img src="${data}" style="width: 60px;height: 60px; border-radius: 5px;object-fit: contain"></div>`;
                        }
                        return '<div></div>';
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {

                    },
                    "targets": 0
                },
                {

                    "render": function (data, type, row) {
                        if (data === 'Active') {
                            return `<p class="badge bg-success p-2">Active</p>`;
                        } else {
                            return `<p class="badge bg-danger p-2">Inactive</p>`;
                        }
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {

                    },
                    "targets": 5
                },
                {

                    "render": function (data, type, row) {
                        if (row[5] === 'Active') {
                            return `<button class="btn btn-danger">Deactivate</button>`;
                        } else {
                            return `<button class="btn btn-success">Activate</button>`;
                        }
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {
                        $(td).click(async (e) => {
                            const data = {
                                status: rowData[5] === 'Active' ? 'Inactive' : 'Active'
                            }
                            await service.update(rowData[7], data);
                            toast.success('Product status changed successfully');
                            getData();
                        })
                    },
                    "targets": 7
                },
                {

                    "render": function (data, type, row) {
                        return `<button class="btn btn-primary">Edit</button>`;
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {
                        $(td).click(e => {
                            // console.log('CLICKED');
                            navigate(`${location.pathname}/edit/${cellData}`);
                        })
                    },
                    "targets": 8
                },
                {

                    "render": function (data, type, row) {
                        return `<button class="btn btn-danger">Delete</button>`;
                    },
                    "createdCell": (td, cellData, rowData, row, col) => {
                        $(td).click(async (e) => {
                            const data = {
                                deleted: true
                            }
                            await service.update(rowData[9], data);
                            toast.success('Product deleted successfully');
                            getData();
                        })
                    },
                    "targets": 9
                },
            ],
            ajax: {
                url: `${baseConfig.apiBaseUrl}/product/list`,
                type: "POST",
                contentType: "application/json",
                headers: {
                    "Authorization": token,
                },
                data: function (d) {
                    return JSON.stringify(d);
                },
            }
        });
    }

    return (
        <div>

            <div className="card mt-3">
                <div className="card-header p-3">
                    <h5 className="card-title">Manage Products</h5>
                </div>
                <div className="card-body">
                    <div className='table-responsive w-100'>
                        <table
                            id="table"
                            className='table datatable w-100'
                        >
                            <thead>
                            <tr>
                                <th>Image</th>
                                <th>Title</th>
                                <th>Price</th>
                                <th>Type</th>
                                <th>Parent</th>
                                <th>Status</th>
                                <th>Added Date</th>
                                <th>Change Status</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>
        </div>
    );
}

export default ManageProducts;
